import React, { useEffect, useState } from 'react'
import { Button, Flex, Message, Modal, Text } from '@workwhile/ui'

import { useVndlyCandidateIssuesContextValue } from '../context/VndlyCandidateIssuesProvider'
import { useVndlyIssuesContextValue } from 'pages/VndlyIssues/context/VndlyIssuesProvider'

type CreateVndlyCandidateButtonProps = {
  workerId: number
  workerName: string
  vndlyInstanceId: number
}

export const CreateVndlyCandidateButton = ({
  workerId,
  workerName,
  vndlyInstanceId,
}: CreateVndlyCandidateButtonProps) => {
  const {
    actions: { createVndlyCandidate, resetCreateVndlyCandidate },
    state: { createVndlyCandidateMutationState },
  } = useVndlyCandidateIssuesContextValue()

  const {
    state: { instances },
  } = useVndlyIssuesContextValue()

  const instanceUrl =
    instances.find((instance) => instance.id === vndlyInstanceId)
      ?.instanceUrl ?? vndlyInstanceId.toString()

  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    if (!createVndlyCandidateMutationState.isSuccess) {
      return
    }

    setIsOpen(false)
    resetCreateVndlyCandidate()
  }, [createVndlyCandidateMutationState.isSuccess, resetCreateVndlyCandidate])

  const handleClick = () => {
    resetCreateVndlyCandidate()
    setIsOpen(true)
  }

  const handleCancel = () => {
    resetCreateVndlyCandidate()
    setIsOpen(false)
  }

  const handleSubmit = () => {
    createVndlyCandidate({
      workerId,
      vndlyInstanceId,
    })
  }

  return (
    <>
      <Button
        variant="secondary"
        kind="small"
        onClick={handleClick}
        style={{ padding: '0 0.5rem' }}
        disabled={createVndlyCandidateMutationState.isPending}
        loading={createVndlyCandidateMutationState.isPending}
      >
        <Text fontSize="12px">Create candidate</Text>
      </Button>
      {isOpen ? (
        <Modal
          open
          onClose={handleCancel}
          title={`Create candidate for ${workerName}`}
        >
          <Text mb={2}>
            Create a VNDLY candidate for {workerName} ({workerId}) on instance{' '}
            {instanceUrl}. The worker must have a first and last name, date of
            birth, zipcode, and SSN on file.
          </Text>
          {createVndlyCandidateMutationState.isError &&
          createVndlyCandidateMutationState.errorMessage ? (
            <Message variant="error" mb={3}>
              {createVndlyCandidateMutationState.errorMessage}
            </Message>
          ) : null}
          <Flex flexDirection="row" justifyContent="space-between" gap={2}>
            <Button variant="secondary" onClick={handleCancel}>
              Cancel
            </Button>
            <Button
              onClick={handleSubmit}
              loading={createVndlyCandidateMutationState.isPending}
              disabled={createVndlyCandidateMutationState.isPending}
            >
              Submit
            </Button>
          </Flex>
        </Modal>
      ) : null}
    </>
  )
}
